import { TableCell, TableRow } from '@material-ui/core';
import { formatDateReadable, formatMoney, PayoutCriteriaList } from '@nemuru-eng/js-api-client';
import { generatePath, Link } from 'react-router-dom';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { useScreen } from '@/hooks/useScreen';
import { DefaultTableProps } from '@/types/defaultTableProps';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface RowProps {
  payout: PayoutCriteriaList['data'][0];
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
}

export const Row = ({ payout, tableProps }: RowProps) => {
  const { isMobile } = useScreen();

  const { classes, stickyCellStyle } = tableProps;
  const linkTo = (id: string) => generatePath(DYNAMIC_PAGE_PATHS.PAYOUT, { payoutId: id });

  const desktopItemRow = (
    <TableRow key={payout.id} className={classes.root}>
      <TableCell align="center" style={isMobile ? stickyCellStyle : {}}>
        <Font variant={'body2'}>{LenderIcon({ lenderName: payout.lender })}</Font>
      </TableCell>
      <TableCell align="right">
        <Font variant={'body2'} style={{ whiteSpace: 'nowrap' }}>
          {formatDateReadable(payout.payoutDate)}
        </Font>
      </TableCell>
      <TableCell align="left">
        <Font variant={'body2'} className="overflow-text-ellipsis">
          {payout.reference}
        </Font>
      </TableCell>
      <TableCell align="right">
        <Font variant={'body2'}>{payout.batchNumber}</Font>
      </TableCell>
      <TableCell align="right">
        <Font variant={'body2'}>{formatMoney(amountToValueMoneyMapper(payout.adjustmentsAmount))}</Font>
      </TableCell>
      <TableCell align="right">
        <Font variant={'body2'}>{formatMoney(amountToValueMoneyMapper(payout.disbursedAmount))}</Font>
      </TableCell>
      <TableCell align="right" style={{ cursor: 'pointer' }}>
        <Link to={linkTo(payout.id)}>
          <Font variant={'body2'}>
            <Icon>arrow_forward</Icon>
          </Font>
        </Link>
      </TableCell>
    </TableRow>
  );

  const mobileItemRow = desktopItemRow;

  return isMobile ? mobileItemRow : desktopItemRow;
};
